import { render } from "./TheHeader.vue?vue&type=template&id=489af88a&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=489af88a&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489af88a"]])

export default __exports__